enum CheckoutTriggerType {
  "Unknown" = 0,
  "NfcTagScanned" = 1,
  "NfcTagManual" = 2,
  "Clicked" = 3,
  "CleaningManagement" = 4,
  "ExternalApi" = 5,
}

export default CheckoutTriggerType;
